module.exports = __webpack_public_path__ + "static/media/carta_15.86a13989.jpg";